export default "__VITE_ASSET__D4s6QNEC__"